module.exports = __webpack_public_path__ + "images/Media_loop.gif";